import * as http from 'transport/utils/http';

export default http;



// WEBPACK FOOTER //
// ./src/shared/utils/http.js